'use strict';

var SaveScenarioNameValidation = function SaveScenarioNameValidation() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ctrl) {
      ctrl.$parsers.unshift(function (value) {
        var regExp = /^[a-z\d\s]+$/i;
        var isValidScenarioName = true;
        var containsOnlyAlphaNumeric = value === '' || !!value.match(regExp);
        var isPreviewScenarioNameUsed = scope.isNotNDAndMDPreviewRequest(value);
        var isActionTypeCreate = scope.actionType === scope.actionTypes.CREATE;
        if (isActionTypeCreate === true) {
          isValidScenarioName = scope.isValidScenarioName(value);
        }
        ctrl.$setValidity('scenarioNameAlreadyUsed', isValidScenarioName);
        ctrl.$setValidity('scenarioNotAlphaNumeric', containsOnlyAlphaNumeric);
        ctrl.$setValidity('previewScenarioNameUsed', isPreviewScenarioNameUsed);
        return isValidScenarioName ? value : undefined;
      });
    }
  };
};
SaveScenarioNameValidation.$inject = [];
module.exports = SaveScenarioNameValidation;